export class Impuesto {
   impuestoId: number;
   nombre: string;
   valor: number;
   tipoImpuesto: number;
   isRetencion: boolean;
   activo: boolean;
   tipoImpuestoObj: any;
   selected?: boolean; 
}
